export const emptyManualKey = "empty";
